import { mapGetters, mapActions, mapMutations } from 'vuex'
import { VMoney } from 'v-money'
import Loading from '@/components/loading/index.vue'

export default {
  components: {
    Loading
  },
  directives: {
    money: VMoney
  },
  props: {
    value: {
      required: true,
      type: Boolean
    }
  },
  data () {
    return {
      creditAdd: '',
      dialog: false,
      isLoading: false
    }
  },
  computed: {
    ...mapGetters([
      'getterAccount',
      'getterSelectedClient'
    ])
  },
  mounted () {
    this.dialog = true
  },
  beforeDestroy () {
    this.SET_SELECTED_CLIENT()
  },
  methods: {
    ...mapActions([
      'actionAddCreditClient'
    ]),
    ...mapMutations([
      'SET_SELECTED_CLIENT'
    ]),
    addCreditClient () {
      const params = {
        client: this.getterSelectedClient,
        credit: parseFloat(this.creditAdd.replace('.', '').replace(',', '.')),
        idUserLogged: this.getterAccount.idUser
      }

      this.isLoading = true

      this.actionAddCreditClient(params)
        .then(() => {
          this.setToDefault()

          this.sendToast({
            text: 'Crédito adicinado para o cliente',
            type: 'success'
          })
        })
        .catch(() => {
          this.sendToast({
            text: 'Não foi possível adicionar crédito para este cliente',
            type: 'danger'
          })

          this.isLoading = false
        })
    },
    closeModal () {
      this.dialog = false

      setTimeout(() => {
        this.$emit('input', false)
      }, 300)
    },
    setToDefault () {
      this.creditAdd = ''
      this.isLoading = false
      this.closeModal()
    }
  }
}
